import sect1_left from '../../../../assets/images/s2_1_1_sect1_left.png';
import sect1_right from '../../../../assets/images/s2_1_1_sect1_right.png';
import s2_1_1_sect2_img1 from '../../../../assets/images/s2_1_1_sect2_img1.png';
import s2_1_1_sect2_img2 from '../../../../assets/images/s2_1_1_sect2_img2.png';
import s2_1_1_sect2_img3 from '../../../../assets/images/s2_1_1_sect2_img3.png';
import s2_1_1_sect2_img4 from '../../../../assets/images/s2_1_1_sect2_img4.png';
import s2_1_1_sect3_img from '../../../../assets/images/s2_1_1_sect3_img.png';

import ProductSlider from '../../common/ProductSlider';
import FixedButton from '../../common/FixedButton';
import GoContact from '../../common/GoContact';

export default function Content() {
  return (
    <>
      <GoContact />

      <div className="s2_1_1_sect2 pt-10">
        <div className="txt-center mb-4">
          <p className="prt-medium fs-22 fc-005eed  mb-1">특징</p>
          <p className="prt-bold fs-40 fc-black1 lh-13">강력한 성능의 T10</p>
        </div>
        <div className="center">
          <div className="col-flex gap-10 mb-5">
            <div className="row-flex-center between m-col-flex m-col-flex">
              <div className="s2_1_1_sect2_item w-48">
                <img src={s2_1_1_sect2_img1} alt="" />
              </div>

              <div className="s2_1_1_sect2_item w-45 txt-left">
                <p className="prt-bold fs-40 fc-black1 mb-3">
                  다양하게 사용할 수 있습니다.
                </p>
                <p className="prt-regular fs-20 fc-a4 lh-15">
                  300º 범위 광각의 센서와 충격흡수 샤시구조를 통해 <br />
                  59cm의 좁은 통로도 막힘없이 이동합니다.
                </p>
              </div>
            </div>

            <div className="row-flex-center between m-col-flex">
              <div className="s2_1_1_sect2_item w-48 pc-none t-none">
                <img src={s2_1_1_sect2_img2} alt="" />
              </div>

              <div className="s2_1_1_sect2_item w-45 txt-right">
                <p className="prt-bold fs-40 fc-black1 mb-3 lh-14">
                  전면의 23.8인치 대형 <br />
                  디스플레이로 뛰어난 광고 효과
                </p>
                <p className="prt-regular fs-20 fc-a4 lh-15">
                  전면 대형 디스플레이에 매장 맞춤형
                  <br />
                  사진 및 영상을 재생할 수 있습니다.
                </p>
              </div>
              <div className="s2_1_1_sect2_item w-48 m-none">
                <img src={s2_1_1_sect2_img2} alt="" />
              </div>
            </div>

            <div className="row-flex-center between m-col-flex">
              <div className="s2_1_1_sect2_item w-48">
                <img src={s2_1_1_sect2_img3} alt="" />
              </div>

              <div className="s2_1_1_sect2_item w-45 txt-left">
                <p className="prt-bold fs-40 fc-black1 mb-3 lh-14">
                  복잡한 구조에서도 뛰어난 <br />
                  주행을 펼칩니다.
                </p>
                <p className="prt-regular fs-20 fc-a4 lh-15">
                  300º 범위의 광각을 감지하는 3D센서와 4개의 스트레오 비전센서를
                  통해
                  <br className="m-none" /> &nbsp;주변 사물을 정확하게 인식하고
                  안전한 서빙을 펼칩니다.
                </p>
              </div>
            </div>

            <div className="row-flex-center between m-col-flex">
              <div className="s2_1_1_sect2_item w-48 pc-none t-none">
                <img src={s2_1_1_sect2_img4} alt="" />
              </div>
              <div className="s2_1_1_sect2_item w-45 txt-right">
                <p className="prt-bold fs-40 fc-black1 mb-3 lh-14">
                  시선을 사로잡는 스마트한 디자인
                </p>
                <p className="prt-regular fs-20 fc-a4 lh-15">
                  상단 디스플레이 부위는 다양한 표정을 지으며 움직입니다. <br />
                  음성, 터치, 비전 등 다양한 방식을 통해
                  <br />
                  사람과 같은 최적의 고객서비스를 펼칩니다.
                </p>
              </div>
              <div className="s2_1_1_sect2_item w-48 m-none">
                <img src={s2_1_1_sect2_img4} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="s2_1_1_sect3 pt-10">
        <div className="center">
          <div className="txt-center mb-4">
            <p className="prt-medium fs-22 fc-005eed  mb-1">제품 사양</p>
            <p className="prt-bold fs-40 fc-black1 lh-13">
              로봇의 상세 스펙을 확인하세요
            </p>
          </div>

          <div className="flex-center mb-4">
            <img src={s2_1_1_sect3_img} alt="" />
          </div>

          <div className="">
            <div className="flex-center col-flex">
              <div className="s2_1_1_sect3_inner w-60 mb-5 m-w-100 t-w-100">
                <div className="row-flex-center between  s2_1_1_sect3_inner_box">
                  <div className="item col-flex flex-center gap-10">
                    <p className="prt-regular fs-16 fc-a4">제품무게</p>
                    <p className="prt-bold fs-28 fc-black1">58kg</p>
                  </div>

                  <div className="item col-flex flex-center gap-10">
                    <p className="prt-regular fs-16 fc-a4">최대 운행 속도</p>
                    <p className="prt-bold fs-28 fc-black1">1 m/s</p>
                  </div>

                  <div className="item col-flex flex-center gap-10">
                    <p className="prt-regular fs-16 fc-a4">적재 중량</p>
                    <p className="prt-bold fs-28 fc-black1">40kg</p>
                  </div>

                  <div className="item col-flex flex-center gap-10">
                    <p className="prt-regular fs-16 fc-a4">최소 이동폭</p>
                    <p className="prt-bold fs-28 fc-black1">59cm</p>
                  </div>
                </div>
              </div>

              <div className="s2_1_1_sect3_inner2 w-70 mb-10 m-w-100 t-w-100">
                <div
                  className="row-flex between w-100 lh-14 
                s2_1_1_sect3_inner2_box m-col-flex t-col-flex"
                >
                  <div className="left w-48 m-w-100 t-w-100">
                    <div className="item ">
                      <div className="row-flex w-100 between txt-left">
                        <p className="prt-semi-bold fs-20 fc-005eed w-30">
                          제품크기
                        </p>
                        <p className="prt-semi-bold fs-20 fc-black1 w-70">
                          48.9 × 55.5 × 139.9cm <br />
                          (19.13” × 21.85” × 54.69”)
                        </p>
                      </div>
                    </div>

                    <div className="item ">
                      <div className="row-flex w-100 between txt-left">
                        <p className="prt-semi-bold fs-20 fc-005eed w-30">
                          최대운행속도
                        </p>
                        <p className="prt-semi-bold fs-20 fc-black1 w-70">
                          1 m/s (2.63 ft/s)
                        </p>
                      </div>
                    </div>

                    <div className="item ">
                      <div className="row-flex w-100 between txt-left">
                        <p className="prt-semi-bold fs-20 fc-005eed w-30">
                          충전시간**
                        </p>
                        <p className="prt-semi-bold fs-20 fc-black1 w-70">
                          5.5시간
                        </p>
                      </div>
                    </div>

                    <div className="item ">
                      <div className="row-flex w-100 between txt-left">
                        <p className="prt-semi-bold fs-20 fc-005eed w-30">
                          적재 중량
                        </p>
                        <p className="prt-semi-bold fs-20 fc-black1 w-70">
                          40kg (88 Ibs)
                        </p>
                      </div>
                    </div>

                    <div className="item ">
                      <div className="row-flex w-100 between txt-left">
                        <p className="prt-semi-bold fs-20 fc-005eed w-30">
                          최소이동폭
                        </p>
                        <p className="prt-semi-bold fs-20 fc-black1 w-70">
                          59cm (23.23”)
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="right w-48 m-w-100 t-w-100">
                    <div className="item min-h-85">
                      <div className="row-flex w-100 between txt-left">
                        <p className="prt-semi-bold fs-20 fc-005eed w-30">
                          제품무게
                        </p>
                        <p className="prt-semi-bold fs-20 fc-black1 w-70">
                          58kg (128 Ibs)
                        </p>
                      </div>
                    </div>

                    <div className="item ">
                      <div className="row-flex w-100 between txt-left">
                        <p className="prt-semi-bold fs-20 fc-005eed w-30">
                          배터리 수명*
                        </p>
                        <p className="prt-semi-bold fs-20 fc-black1 w-70">
                          완충시 최대 18시간
                        </p>
                      </div>
                    </div>

                    <div className="item ">
                      <div className="row-flex w-100 between txt-left">
                        <p className="prt-semi-bold fs-20 fc-005eed w-30">
                          트레이 사이즈
                        </p>
                        <p className="prt-semi-bold fs-20 fc-black1 w-70 lh-15">
                          1/2/3층 : <br />
                          48.6 × 41.6cm (19.13” × 16.38”) <br />
                          하단층 : <br />
                          35.0 × 28.6cm (13.78” × 11.26”)
                        </p>
                      </div>
                    </div>
                    <div className="item ">
                      <div className="row-flex w-100 between txt-left">
                        <p className="prt-semi-bold fs-20 fc-005eed w-30">
                          터치 스크린 <br className="pc-none" />
                          크기 폭
                        </p>
                        <p className="prt-semi-bold fs-20 fc-black1 w-70">
                          11.6” (1920 × 1080)
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="sub_desc prt-light fs-14 fc-888 txt-left lh-15">
                  *배터리와 관련된 모든 설명은 기타 다양한 요인에 의해 제약되며,
                  실제 결과는 다를 수 있습니다.
                  <br />
                  배터리 충전 횟수는 제한되어 결국 교체가 필요할 수 있습니다.
                  배터리 수명과 충전횟수는 사용 및 설정에 따라 다릅니다.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ProductSlider></ProductSlider>
      <FixedButton></FixedButton>
    </>
  );
}
